// extracted by mini-css-extract-plugin
module.exports = {"container":"SwellEventCardContainer_container__Q0l_t","swellEventCardWrapper":"SwellEventCardContainer_swellEventCardWrapper__lsyb0"};